import * as Actions from '../../actions';

const initialState = { data: null };

const listHaulingChargesReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_HAULING_CHARGE_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listHaulingChargesReducer;
